module.exports = __webpack_public_path__ + "5b9106a3d18ed46b21f50cee5c014a7b.svg";